// api
import { fetchApi } from '@/api'
// actions
const adminSchoolsAll = (context) => {
  let url = 'admin/schools'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_SCHOOLS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminSchoolsForm = (context) => {
  let url = 'admin/schools/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_SCHOOLS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminSchoolsShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'admin/schools/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_SCHOOLS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const adminSchoolsCreate = (context, payload) => {
  let url = 'admin/schools'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('ADMIN_SCHOOLS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminSchoolsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/schools/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_SCHOOLS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminSchoolsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/schools/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('ADMIN_SCHOOLS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  adminSchoolsAll,
  adminSchoolsForm,
  adminSchoolsShow,
  adminSchoolsCreate,
  adminSchoolsUpdate,
  adminSchoolsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/schools/actions.js